<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <h2>Lista de Inadimplentes</h2>
            </div>
            <!-- FILTROS -->
            <div>
                <validation-observer ref="forms" v-slot="{handleSubmit}">
                    <form class="form-group" @submit.prevent="handleSubmit(getInadimplentes)">
                        <div class="flex items-start">
                            <validation-provider
                                name="CNPJ"
                                vid="cnpj"
                                v-slot="{errors}"
                                tag="div"
                                class="input-std form-text"
                            >
                                <input type="text" v-model="usuarios.filtros.search" class="text-black mr-3" placeholder="Digite o CNPJ" v-mask="'##.###.###/####-##'">
                                <p class="errors text-sm">{{ errors[0] }}</p>
                            </validation-provider>
                            <button class="btn btn-primary ml-3" type="submit" style="height: 50px">Enviar</button>
                        </div>
                    </form>
                </validation-observer>
            </div>
            <!-- FILTROS -->
            <div class="card-body">
                <vue-good-table
                    mode="remote"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="usuarios.columns"
                    :rows="usuarios.rows"
                    :totalRows="usuarios.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos',
                      }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhum dado á ser exibido.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field === 'inadimplencia'">
                            <span>{{ props.row.inadimplente == 1 ? 'Inadimplente' : '' }}</span>
                        </div>
                        <div v-if="props.column.field === 'acoes'" class="flex flex-col">
                            <button
                                class="bg-transparent hover:bg-red-600 text-red-600 font-semibold hover:text-white py-2 px-4 border border-red-600 hover:border-transparent rounded"
                                @click="alterarStatus(props.row.id, props.row.inadimplente)">Alterar Status
                            </button>
                        </div>
                        <span>
              {{ props.formattedRow[props.column.field] }}
            </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import {VueGoodTable} from "vue-good-table";
import { mask } from "vue-the-mask";

export default {
    name: "tabela-usuarios",

    directives: { mask },
    components: {
        VueGoodTable,
    },

    created() {
        this.getInadimplentes();
    },

    data() {
        return {
            usuarios: {
                columns: [
                    {label: "Cnpj", field: "cnpj"},
                    {label: "Nome", field: "name"},
                    {label: "E-mail", field: "email"},
                    {label: "Inadimplente", field: "inadimplencia"},
                    {
                        label: "Ações",
                        field: "acoes",
                        filterable: false,
                        sortable: false,
                    },
                ],
                rows: [],
                total: 0,
                filtros: {
                    search: '',
                    sort: {
                        field: "id",
                        type: "desc",
                    },
                    page: 1,
                    perPage: 10,
                },
            },
        };
    },

    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarEventos({page: params.currentPage});
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarEventos({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarEventos({perPage: params.currentPerPage});
        },

        /**
         * Filtra os usuarios conforme as mudanças
         * @param newProps
         */
        filtrarEventos(newProps) {
            this.usuarios.filtros = Object.assign({}, this.usuarios.filtros, newProps);
            this.getInadimplentes();
        },

        getInadimplentes() {
            this.axios("get-inadimplentes", {
                params: {
                    search: this.usuarios.filtros.search,
                    page: this.usuarios.filtros.page,
                    per_page: this.usuarios.filtros.perPage,
                    sort_field: this.usuarios.filtros.sort.field,
                    sort_type: this.usuarios.filtros.sort.type,
                },
            }).then((response) => {
                this.usuarios.rows = response.data.users.data;
                this.usuarios.total = response.data.users.total;
            });
        },

        alterarStatus(id, status) {
            this.axios.post('inadimplentes', {
                'id': id,
                'status': status == 1 ? 0 : 1
            })
                .then(response => {
                    this.getInadimplentes()
                    this.$swal({
                        title: "Sucesso",
                        text: "Status alterado.",
                        type: "success",
                        icon: 'success'
                    });
                })
                .catch((error) => {
                    this.$swal({
                        title: "Algo de errado ocorreu",
                        text: error.response.data.message,
                        type: "error",
                        icon: 'error'
                    });
                });
        }
    },
};
</script>
